export const namespace = 'font/';
